import React from "react";

const AuthLoader = () => {
    return (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white">
            <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
            <p className="mt-4 text-sm font-medium text-gray-600">
                Verifying your session...
            </p>
        </div>
    );
};

export default AuthLoader;